import { Form } from "antd";
import { useEffect } from "react";
import { FormModal } from "@/shared/components/FormModal";
import { useCreateFaceEnrollment, useUpdateFaceEnrollment } from "../hooks/useFaceEnrollment";
import { useFaceEnrollmentStore } from "../store/face-enrollment.store";
import type { CreateFaceEnrollmentRequest, UpdateFaceEnrollmentRequest } from "../types";
import { FaceEnrollmentForm } from "./FaceEnrollmentForm";

interface FaceEnrollmentModalProps {
	organizationId: string;
}

export function FaceEnrollmentModal({ organizationId }: FaceEnrollmentModalProps) {
	const [form] = Form.useForm<CreateFaceEnrollmentRequest>();
	const { modalOpen, editingItem, closeModal } = useFaceEnrollmentStore();

	const { mutate: create, isPending: isCreating } = useCreateFaceEnrollment();
	const { mutate: update, isPending: isUpdating } = useUpdateFaceEnrollment();

	useEffect(() => {
		if (editingItem) {
			form.setFieldsValue({
				ownerType: editingItem.ownerType,
				staffId: editingItem.staffId || undefined,
				faceImageId: editingItem.faceImageId,
				organizationId: editingItem.organizationId,
			});
		} else {
			form.resetFields();
		}
	}, [editingItem, form]);

	const handleClose = () => {
		closeModal();
		form.resetFields();
	};

	const handleSubmit = () => {
		form.validateFields().then((values) => {
			if (editingItem) {
				const updateData: UpdateFaceEnrollmentRequest = {
					faceImageId: values.faceImageId,
				};
				update({ id: editingItem.id, data: updateData }, { onSuccess: handleClose });
			} else {
				create(values, { onSuccess: handleClose });
			}
		});
	};

	return (
		<FormModal
			editing={Boolean(editingItem)}
			title="Yangi yuz ro'yxatan o'tkazish"
			editTitle="Yuz ma'lumotlarini tahrirlash"
			open={modalOpen}
			onCancel={handleClose}
			onOk={handleSubmit}
			confirmLoading={isCreating || isUpdating}
		>
			<FaceEnrollmentForm
				form={form}
				organizationId={editingItem?.organizationId || organizationId}
			/>
		</FormModal>
	);
}
